const MovieShimmer = () => {
  return (
    <div>
      <div className="w-full h-screen bg-[#1a2945]">
        <div className="pt-[20%] px-10 ">
          <div className=" bg-gray-600 rounded-lg animate-pulse w-1/2 py-6 my-2"></div>
          <div className="bg-gray-600 rounded-lg animate-pulse w-1/3 py-2 my-2"></div>

          <div className="bg-gray-600 rounded-lg animate-pulse w-1/4 py-2 my-2"></div>
          <div className="bg-gray-600 rounded-lg animate-pulse w-1/3 py-2 my-2"></div>

          <div className="bg-gray-600 rounded-lg animate-pulse w-1/4 py-2 my-2"></div>
          <div className="bg-gray-600 rounded-lg animate-pulse w-1/5 py-2 my-2"></div>
        </div>
      </div>
    </div>
  );
};

export default MovieShimmer;
